<template>
    <div>
        <div v-for="offer_by_date in data" :key="offer_by_date.id">
            <div class="month" :class="{ 'blur': offer_by_date.is_paid_active }">
                <span>{{ offer_by_date.month }} {{ offer_by_date.year }}</span>
                <div class="line"></div>
            </div>
            <div v-for="(offer, index) in offer_by_date.offers" :key="offer.id" class="relative">
                <offers-alert-tomany v-if="!is_paid && getOfferCount(offer_by_date, index) === 4" />
                <div :class="{ 'offer-row': offer.offer.is_paid_active }">
                    <offer-row :data="offer" :user="user" :is_paid="is_paid" :sendEmail="sendEmail" @openKlientModal="openKlientModal($event)"
                        @resetOpens="resetOpens($event)" @changeSendStatus="changeSendStatus($event)"
                        @deleteOffer="deleteOffer($event)" @de_activeOffer="de_activeOffer($event)"
                        @isFormConfirmed="isFormConfirmed($event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OffersAlertTomany from "./OffersAlertTomany.vue";
import OfferRow from "./OfferRow.vue";
export default {
    components: { OfferRow, OffersAlertTomany },
    props: ["data", "user", "is_paid", "sendEmail"],
    data() {
        return {
            offer_count: 0,
        };
    },
    methods: {
        getOfferCount(currentMonth, currentIndex) {
            let count = 0;
            for (const month of this.data) {
                if (month === currentMonth) {
                    count += currentIndex + 1;
                    break;
                }
                count += month.offers.length;
            }
            return count;
        },
        openKlientModal(id) {
            this.$emit("openKlientModal", id);
        },
        resetOpens(id) {
            this.$emit("resetOpens", id);
        },
        changeSendStatus(uuid) {
            this.$emit("changeSendStatus", uuid);
        },
        deleteOffer(id) {
            this.$emit("deleteOffer", id);
        },
        de_activeOffer(uuid) {
            this.$emit("de_activeOffer", uuid);
        },
        isFormConfirmed(uuid) {
            this.$emit("isFormConfirmed", uuid);
        },
    },
};
</script>

<style lang="scss" scoped>
.month {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
    margin-bottom: 8px;

    span {
        white-space: pre;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #212541;
        margin-right: 23px;
    }

    .line {
        width: 100%;
        border: 1px solid #f2f2f2;
    }
}

.offer-row {
    filter: blur(10px);
    pointer-events: none;
}
</style>
